class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => {
      if (evt.code !== 'Escape') return;
      // Close an open shipping/note popup first; otherwise close the whole drawer.
      if (!this.closeActivePopup()) this.close();
    });
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
  }
  connectedCallback() {
    this.init();

    requestAnimationFrame(() => {
      this.setHeaderCartIconAccessibility();
    });
  }

  init() {
    this.removeEventListener('click', this._delegatedHandler);

    this._delegatedHandler = (e) => {

      const target = e.target;

      if (target.closest('.discount-btn')) {
        this.cartDiscount();
      }

      if (target.closest('.discount-item .close-the-daw-upper')) {
        this.cartDiscountClose();
      }

      if (target.closest('.apply-btn-dis')) {
        this.discountApply()
      }


      if (target.closest('.shipping-btn')) {
        this.shNote();
      }

      if (target.closest('.shipping-item .close-the-daw-upper')) {
        this.shNoteClose();
      }


      if (target.closest('.note-btn')) {
        this.openNote();
      }

      if (target.closest('.note-item .close-the-daw-upper') || target.closest('.apply-btn')) {
        this.closeNote();
      }

    };


    this.addEventListener('click', this._delegatedHandler);
    this.initializeShippingEstimators();
  }
  discountApply() {
    const disCodeInput = this.querySelector('input[name=dis_field]');
    const disTextInfo = this.querySelector('#discount-info-text');
    disTextInfo.classList.remove('visually-hidden');
    disTextInfo.textContent = 'Applying...';
    if (!disCodeInput) return;
    const disCodeVal = disCodeInput.value.trim();
    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        discount: disCodeVal,
        sections: this.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      })
    })
      .then(response => response.json())
      .then(cart => {
        // console.log('Discount response:', cart);
        // Check if applicable is true for the discount code
        const isApplicable = cart.discount_codes && cart.discount_codes.some(d => d.applicable === true);
        if (isApplicable) {
          // console.log('Discount applied successfully! Updating UI...');
          // Update cart drawer and cart bubble UI using Section Rendering API
          disTextInfo.classList.remove('error-dis');
          disTextInfo.classList.add('success-dis');
          disTextInfo.textContent = 'Discount applied successfully!';
          setTimeout(() => {
            this.renderContents(cart);
          }, 2000);
        } else {
          // console.warn('Discount code entered is not applicable or invalid.');
          disTextInfo.classList.remove('success-dis');
          disTextInfo.classList.add('error-dis');
          disTextInfo.textContent = 'Discount code is not applicable or invalid.';
        }
        setTimeout(() => {
          disTextInfo.textContent = '';
          disTextInfo.classList.add('visually-hidden');
          disTextInfo.classList.remove('success-dis');
          disTextInfo.classList.remove('error-dis');
        }, 4000);
      })
      .catch(error => {
        console.error('Error applying discount:', error);
      });
  }
  disCodeUpdate(intent, oldCode, newCode = null) {
    // Clean up the current codes into an array, removing empty spaces
    let codeArray = oldCode ? oldCode.split(',').map(c => c.trim()) : [];

    if (intent === 'newCodeApply' && newCode) {
      // 1. Add new code if it doesn't already exist
      if (!codeArray.includes(newCode.trim())) {
        codeArray.push(newCode.trim());
      }
    }

    else if (intent === 'oldCodeRemove' && newCode) {
      // 2. Remove the specific code
      codeArray = codeArray.filter(c => c !== newCode.trim());
    }

    // Return the updated comma-separated string safely
    return codeArray.filter(Boolean).join(',');
  }

  initializeShippingEstimators() {
    if (typeof window.initializeShippingEstimator !== 'function') return;

    this.querySelectorAll('.shipping-estimator-container').forEach((container) => {
      window.initializeShippingEstimator(container);
    });
  }

  cartDiscount() {
    this.openCartPopup('.discount-item', '.discount-btn');
  }
  cartDiscountClose() {
    this.closeCartPopup('.discount-item', '.discount-btn');
  }



  shNote() {
    this.openCartPopup('.shipping-item', '.shipping-btn');
  }

  shNoteClose() {
    this.closeCartPopup('.shipping-item', '.shipping-btn');
  }


  openNote() {
    this.openCartPopup('.note-item', '.note-btn');
  }

  closeNote() {
    this.closeCartPopup('.note-item', '.note-btn');
  }

  // Open a cart-drawer popup (shipping estimate / order note) and confine keyboard
  // focus to it. Without trapping, Tab/Shift+Tab leak to the cart items behind the
  // popup because the drawer's focus trap spans the whole drawer; this also moves
  // focus into the popup on open.
  openCartPopup(popupSelector, triggerSelector) {
    const popup = this.querySelector(popupSelector);
    if (!popup) return;
    clearTimeout(this.popupCloseTimer);
    this.popupReturnFocus = document.activeElement;
    const popupWrapper = this.querySelector('.cart-btn-popup');
    popupWrapper?.classList.remove('closing');
    popup.classList.remove('closing');
    popupWrapper?.classList.add('active');
    popup.classList.add('active');
    const focusTarget =
      popup.querySelector('select:enabled, input:not([type="hidden"]):enabled, textarea:enabled') ||
      popup.querySelector('button') ||
      popup;
    trapFocus(popup, focusTarget);
  }

  // Close a cart-drawer popup, restore the drawer's focus trap, and return focus
  // to the button that opened it.
  closeCartPopup(popupSelector, triggerSelector) {
    const popup = this.querySelector(popupSelector);
    if (!popup) return;
    const popupWrapper = this.querySelector('.cart-btn-popup');
    clearTimeout(this.popupCloseTimer);
    popup.classList.remove('active');
    popup.classList.add('closing');
    popupWrapper?.classList.remove('active');
    popupWrapper?.classList.add('closing');
    this.popupCloseTimer = setTimeout(() => {
      popup.classList.remove('closing');
      popupWrapper?.classList.remove('closing');
    }, 300);
    // Return focus to whatever opened the popup; fall back to the trigger button
    // (if rendered) or the drawer dialog so focus is never lost.
    const returnTo =
      this.popupReturnFocus && this.popupReturnFocus.isConnected && this.contains(this.popupReturnFocus)
        ? this.popupReturnFocus
        : this.querySelector(triggerSelector) || this.querySelector('.drawer__inner');
    trapFocus(document.getElementById('CartDrawer'), returnTo);
  }

  // Close whichever popup is open (so Escape dismisses the popup before the drawer).
  // Returns true if a popup was open.
  closeActivePopup() {
    if (this.querySelector('.shipping-item.active')) {
      this.shNoteClose();
      return true;
    }
    if (this.querySelector('.note-item.active')) {
      this.closeNote();
      return true;
    }
    if (this.querySelector('.discount-item.active')) {
      this.cartDiscountClose();
      return true;
    }
    return false;
  }


  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;


    if (cartLink.hasAttribute('data-cart-drawer-setup')) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.setAttribute('data-cart-drawer-setup', 'true');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }


  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        // The close button lives in the always-visible header (outside .drawer__inner-empty),
        // so trap focus on the whole #CartDrawer in both states. Trapping only on
        // .drawer__inner-empty strands keyboard focus on "Continue shopping" with no way to
        // Tab to the close button when the cart is empty.
        const containerToTrapFocusOn = document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    // Reset any open popup so it doesn't linger (and strand focus) on reopen.
    clearTimeout(this.popupCloseTimer);
    this.querySelectorAll('.popup-content').forEach((popup) => popup.classList.remove('active', 'closing'));
    this.querySelector('.cart-btn-popup')?.classList.remove('active', 'closing');
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }


  async renderContents(parsedState) {
    let renderedSections = parsedState?.sections;
    let cartDrawerContent = this.getSectionInnerHTML(renderedSections?.['cart-drawer'], '#CartDrawer');

    if (cartDrawerContent === null) {
      try {
        renderedSections = await this.fetchSectionsToRender();
        cartDrawerContent = this.getSectionInnerHTML(renderedSections?.['cart-drawer'], '#CartDrawer');
      } catch (error) {
        console.error('Unable to refresh the cart drawer sections.', error);
      }
    }

    if (cartDrawerContent === null) {
      this.open();
      return;
    }

    this.classList.contains('is-empty') && this.classList.remove('is-empty');

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;

      const sectionContent =
        section.id === 'cart-drawer'
          ? cartDrawerContent
          : this.getSectionInnerHTML(renderedSections[section.id], section.selector);

      if (sectionContent === null) return;

      sectionElement.innerHTML = sectionContent;
    });


    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
    this.open();
    this.init();
  }

  async fetchSectionsToRender() {
    const sectionUrl = new URL(window.Shopify?.routes?.root || window.location.pathname, window.location.origin);
    sectionUrl.searchParams.set(
      'sections',
      this.getSectionsToRender().map((section) => section.id).join(',')
    );

    const response = await fetch(sectionUrl.toString(), {
      cache: 'no-store',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });

    if (!response.ok) throw new Error(`Section request failed with status ${response.status}`);

    return response.json();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (typeof html !== 'string') return null;

    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML ?? null;
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  connectedCallback() {
    super.connectedCallback();
    const cartDrawer = this.closest('cart-drawer');
    if (typeof cartDrawer?.initializeShippingEstimators === 'function') {
      cartDrawer.initializeShippingEstimators();
    }
  }

  getSectionsToRender() {
    return [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

document.addEventListener('shopify:section:load', () => {
  const drawer = document.querySelector('cart-drawer');
  drawer?.setHeaderCartIconAccessibility();
});

document.addEventListener('shopify:section:reorder', () => {
  const drawer = document.querySelector('cart-drawer');
  drawer?.setHeaderCartIconAccessibility();
});
